(function() {
  var chatOpenClass = 'mobile-chat-is-open';
  var hiddenClass = 'av-hide-while-chat-open';
  var chatSelector = '#cx-armin-chat-widget-v2';
  var frameSelector = 'iframe[title="Armin CX Chat Widget"]';
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var scheduled = false;
  var chatRoot = null;
  var chatObserver = null;
  var pendingWidgets = new Set();
  var watchedWidgets = new Set();
  var widgetObserver = window.MutationObserver ? new MutationObserver(onWidgetChanges) : null;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(scheduleUpdate) : null;

  function normalizeText(value) {
    value = String(value || '').toLowerCase();

    if (value.normalize) {
      value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return value;
  }

  function getDescriptor(el) {
    var text = '';

    if (!el.children || el.children.length <= 6) {
      text = el.textContent || '';
    }

    return normalizeText([
      el.id,
      el.className,
      el.getAttribute && el.getAttribute('src'),
      el.getAttribute && el.getAttribute('title'),
      el.getAttribute && el.getAttribute('aria-label'),
      el.getAttribute && el.getAttribute('data-testid'),
      text
    ].join(' '));
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;

    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);

    return rect.width > 0 &&
      rect.height > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || 1) !== 0;
  }

  function isLargeSurface(el) {
    if (!isVisible(el)) return false;

    var rect = el.getBoundingClientRect();

    return rect.width >= window.innerWidth * 0.65 &&
      rect.height >= window.innerHeight * 0.45;
  }

  function isFixedLike(el) {
    if (!isVisible(el)) return false;

    var style = window.getComputedStyle(el);
    var zIndex = parseInt(style.zIndex, 10) || 0;

    return style.position === 'fixed' ||
      style.position === 'sticky' ||
      zIndex >= 900;
  }

  function isChatDescriptor(descriptor) {
    return descriptor.indexOf('cx-widget') > -1 ||
      descriptor.indexOf('cx_armin') > -1 ||
      descriptor.indexOf('chatarmin') > -1 ||
      descriptor.indexOf('armin.cx') > -1 ||
      descriptor.indexOf('ki-agent') > -1 ||
      descriptor.indexOf('frag uns') > -1 ||
      descriptor.indexOf('unterstutzt von armin.cx') > -1;
  }

  function isProtectedOverlay(el, descriptor) {
    if (el.closest(chatSelector) || isChatDescriptor(descriptor)) return true;
    if (descriptor.indexOf('grecaptcha') > -1 || descriptor.indexOf('recaptcha') > -1) return true;
    if (descriptor.indexOf('cookie') > -1 || descriptor.indexOf('consent') > -1) return true;

    var node = el.parentElement;
    var depth = 0;

    while (node && node !== document.body && depth < 6) {
      if (isChatDescriptor(getDescriptor(node))) return true;
      node = node.parentElement;
      depth += 1;
    }

    return false;
  }

  function isChatOpen() {
    if (!chatRoot || !chatRoot.isConnected) return false;
    var frames = chatRoot.querySelectorAll(frameSelector);
    for (var i = 0; i < frames.length; i += 1) {
      var frame = frames[i];
      if (!isLargeSurface(frame)) continue;
      var parent = frame.parentElement;
      var visible = true;
      while (parent && parent !== chatRoot) {
        if (!isVisible(parent)) { visible = false; break; }
        parent = parent.parentElement;
      }
      var rootStyle = window.getComputedStyle(chatRoot);
      if (visible && rootStyle.display !== 'none' && rootStyle.visibility !== 'hidden' && Number(rootStyle.opacity || 1) !== 0) return true;
    }
    return false;
  }

  function isBlockingEdgeOverlay(el) {
    if (!isVisible(el) || !isFixedLike(el)) return false;

    var rect = el.getBoundingClientRect();
    var descriptor = getDescriptor(el);

    if (isProtectedOverlay(el, descriptor)) return false;

    var isFeedback = descriptor.indexOf('ruckmeldung') > -1 ||
      descriptor.indexOf('feedback') > -1;
    var isTrusted = descriptor.indexOf('etrusted') > -1 ||
      descriptor.indexOf('trustedshops') > -1 ||
      descriptor.indexOf('trustbadge') > -1;

    var leftTab = rect.left <= 8 &&
      rect.top > 90 &&
      rect.width <= 150 &&
      rect.height >= 50 &&
      rect.height <= window.innerHeight * 0.7;
    var smallBadge = rect.top > 90 &&
      rect.width <= 220 &&
      rect.height <= 260 &&
      (rect.left <= 24 || rect.right >= window.innerWidth - 24 || rect.bottom >= window.innerHeight - 24);

    return leftTab || smallBadge || (isFeedback || isTrusted);
  }

  function clearHiddenWidgets() {
    document.querySelectorAll('.' + hiddenClass).forEach(function(el) {
      el.classList.remove(hiddenClass);
    });
  }

  function withoutHiddenClass(value) {
    return String(value || '').split(/\s+/).filter(function(name) { return name && name !== hiddenClass; }).sort().join(' ');
  }

  function onWidgetChanges(records) {
    if (!document.body || !document.body.classList.contains(chatOpenClass)) return;
    records.forEach(function(record) {
      if (record.attributeName === 'class' && withoutHiddenClass(record.oldValue) === withoutHiddenClass(record.target.getAttribute('class'))) return;
      pendingWidgets.add(record.target);
    });
    if (pendingWidgets.size) scheduleUpdate();
  }

  function observeWidget(el) {
    if (!widgetObserver || el === document.body || el.closest(chatSelector)) return;
    var descriptor = getDescriptor(el);
    if (isProtectedOverlay(el, descriptor)) return;
    var style = window.getComputedStyle(el);
    if (style.position !== 'fixed' && style.position !== 'sticky' && (parseInt(style.zIndex, 10) || 0) < 900 && !/etrusted|trustedshops|trustbadge|feedback|ruckmeldung/.test(descriptor)) return;
    for (var node = el; node && node !== document.body; node = node.parentElement) {
      if (!watchedWidgets.has(node)) {
        watchedWidgets.add(node);
        widgetObserver.observe(node, { attributes: true, attributeOldValue: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
      }
    }
  }

  function markEdgeOverlayWidgets(root) {
    if (!root || root.nodeType !== 1 || !root.isConnected) return;
    var nodes = [root].concat(Array.from(root.querySelectorAll('iframe, [id], [class], [aria-label], [title], div, span, button, a, etrusted-widget')));
    nodes.forEach(function(el) {
      observeWidget(el);
      if (!el.closest('.' + hiddenClass) && isBlockingEdgeOverlay(el)) el.classList.add(hiddenClass);
    });
  }

  function updateChatOverlayState() {
    scheduled = false;
    if (!document.body || document.hidden) return;
    var chatOpen = mobileQuery.matches && isChatOpen();
    var wasOpen = document.body.classList.contains(chatOpenClass);
    if (chatOpen !== wasOpen) {
      document.body.classList.toggle(chatOpenClass, chatOpen);
      if (chatOpen) pendingWidgets.add(document.body);
      else {
        if (widgetObserver) widgetObserver.disconnect();
        watchedWidgets.clear();
        clearHiddenWidgets();
      }
    }
    if (chatOpen) pendingWidgets.forEach(markEdgeOverlayWidgets);
    pendingWidgets.clear();
  }

  function scheduleUpdate() {
    if (scheduled || document.hidden) return;
    scheduled = true;
    window.requestAnimationFrame(updateChatOverlayState);
  }

  function observeFrames() {
    if (!resizeObserver || !chatRoot) return;
    chatRoot.querySelectorAll(frameSelector).forEach(function(frame) {
      resizeObserver.observe(frame);
      if (frame.parentElement) resizeObserver.observe(frame.parentElement);
    });
  }

  function bindChat(root) {
    if (root === chatRoot) return;
    if (chatObserver) chatObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    chatRoot = root;
    if (chatRoot && window.MutationObserver) {
      chatObserver = new MutationObserver(function() { observeFrames(); scheduleUpdate(); });
      chatObserver.observe(chatRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
      observeFrames();
    }
    scheduleUpdate();
  }

  function refreshViewport() {
    if (document.body && document.body.classList.contains(chatOpenClass)) pendingWidgets.add(document.body);
    scheduleUpdate();
  }

  function initChatOverlay() {
    bindChat(document.querySelector(chatSelector));
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function(records) {
      if (chatRoot && !chatRoot.isConnected) bindChat(null);
      records.forEach(function(record) {
        record.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (!chatRoot) {
            var root = node.matches(chatSelector) ? node : node.querySelector(chatSelector);
            if (root) bindChat(root);
          }
          if (document.body.classList.contains(chatOpenClass)) pendingWidgets.add(node);
        });
      });
      if (pendingWidgets.size) scheduleUpdate();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initChatOverlay, { once: true });
  else initChatOverlay();
  window.addEventListener('resize', refreshViewport);
  window.addEventListener('orientationchange', refreshViewport);
  window.addEventListener('pageshow', refreshViewport);
  document.addEventListener('visibilitychange', refreshViewport);
  if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', refreshViewport);
})();
